import { createFrontendPlugin } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { Icon } from '@iconify/react';
import {
  isOrganisationDsoEntity,
  isOrganisationEntity,
  isSolutionEntity,
} from '@ipen-portal/ipen-entity-model';
import { or } from '@ipen-portal/plugin-common';
import { TrpcApiBlueprint } from '@ipen-portal/plugin-trpc-react';

import { deliveryProcessApiRef } from './trpc';

export const deliveryProcessPlugin = createFrontendPlugin({
  extensions: [
    TrpcApiBlueprint.make({
      name: 'delivery-process-api',
      params: defineParams =>
        defineParams({
          apiRef: deliveryProcessApiRef,
          path: 'delivery-process',
        }),
    }),
    EntityContentBlueprint.make({
      name: 'DeliveryProcessList',
      params: {
        filter: or(
          isOrganisationDsoEntity,
          isOrganisationEntity,
          isSolutionEntity,
        ),
        icon: <Icon icon="ri:apps-2-add-line" />,
        loader: async () =>
          import('./pages/DeliveryProcessPage').then(m => (
            <m.DeliveryProcessPage />
          )),
        path: '/delivery-process',
        title: 'Delivery Process',
      },
    }),
  ],
  pluginId: 'delivery-process',
});
